import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class APIService {
  private urlPrefix = `${environment.apiDomain}`;

  constructor(private http: HttpClient) {}

  get<T>(
    endpoint: string,
    params?: HttpParams | Record<string, unknown> | object,
    options?: { headers?: HttpHeaders; withCredentials?: boolean },
  ): Observable<T> {
    return this.http.get<T>(`${this.urlPrefix}${endpoint}`, {
      params: this.toHttpParams(params),
      ...options,
    });
  }

  private toHttpParams(input?: HttpParams | Record<string, unknown> | object): HttpParams | undefined {
    if (input === undefined) {
      return undefined;
    }
    if (input instanceof HttpParams) {
      return input;
    }
    const record = input as Record<string, unknown>;
    let params = new HttpParams();
    for (const key of Object.keys(record)) {
      const value = record[key];
      if (value === undefined || value === null) {
        continue;
      }
      if (Array.isArray(value)) {
        for (const el of value) {
          if (el === undefined || el === null) {
            continue;
          }
          params = params.append(key, String(el));
        }
      } else if (value instanceof Date) {
        params = params.set(key, value.toISOString());
      } else {
        params = params.set(key, String(value));
      }
    }
    return params;
  }

  post<T>(endpoint: string, body: any, options?: { headers?: HttpHeaders; withCredentials?: boolean }): Observable<T> {
    return this.http.post<T>(`${this.urlPrefix}${endpoint}`, body, options);
  }

  put<T>(endpoint: string, body: any, options?: { headers?: HttpHeaders; withCredentials?: boolean }): Observable<T> {
    return this.http.put<T>(`${this.urlPrefix}${endpoint}`, body, options);
  }

  patch<T>(endpoint: string, body: any, options?: { headers?: HttpHeaders; withCredentials?: boolean }): Observable<T> {
    return this.http.patch<T>(`${this.urlPrefix}${endpoint}`, body, options);
  }

  delete<T>(endpoint: string, options?: { headers?: HttpHeaders; withCredentials?: boolean }): Observable<T> {
    return this.http.delete<T>(`${this.urlPrefix}${endpoint}`, options);
  }
}
